import countries from "../../../countries.json";

// "Made In" display helper (ticket §1) -- ProviderProduct.countryOfOrigin is stored as an ISO
// 3166-1 alpha-2 code (see the model's own comment); this turns it into the Country name +
// flag Elakay already has via countries.json, the SAME list the Provider picks from in
// ProviderProductForm.jsx. Never invents a country: returns null when the code is unset or
// isn't a real one in that list.
const byCode = new Map(countries.map((c) => [c.code.toUpperCase(), c.name]));

// Regional indicator trick: each ISO-2 letter maps 1:1 to a Unicode "regional indicator symbol"
// (U+1F1E6 = 'A'); two of them next to each other render as that country's flag emoji.
const flagOf = (code) => {
  if (!/^[A-Z]{2}$/.test(code)) return "";
  return String.fromCodePoint(...[...code].map((ch) => 0x1f1e6 + (ch.charCodeAt(0) - 65)));
};

export const countryOfOrigin = (code) => {
  const normalized = String(code || "").trim().toUpperCase();
  const name = byCode.get(normalized);
  if (!name) return null;
  return { code: normalized, name, flag: flagOf(normalized) };
};
